export default "__VITE_ASSET__D810XTXv__"